module.exports = __webpack_public_path__ + "img/gnu_gallery1.99c8daab.jpg";